import React, { useState } from 'react';

export default function CookieConsent() {
  const [accepted, setAccepted] = useState(() => {
    try { return localStorage.getItem('cookie_consent') === '1'; } catch { return false; }
  });

  if (accepted) return null;

  const accept = () => {
    setAccepted(true);
    try { localStorage.setItem('cookie_consent', '1'); } catch {}
  };

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#1e293b', borderTop: '1px solid #334155',
      padding: '14px 24px', display: 'flex', alignItems: 'center',
      justifyContent: 'center', gap: 16, flexWrap: 'wrap',
      fontSize: 13, color: '#cbd5e1',
    }}>
      <span>
        This site uses essential cookies for authentication and session management.
        See our <a href="/docs/privacy" style={{ color: '#38bdf8', textDecoration: 'underline' }}>Privacy Policy</a> for details.
      </span>
      <button
        onClick={accept}
        style={{
          background: '#f43f5e', border: 'none', borderRadius: 6, color: '#fff',
          fontWeight: 600, fontSize: 13, padding: '8px 20px', cursor: 'pointer',
          whiteSpace: 'nowrap', flexShrink: 0,
        }}
      >Accept</button>
    </div>
  );
}
